import MicroModal from 'micromodal'

/**
 * Displays the vimeo video.
 */
export default function video() {
  Array.from( document.querySelectorAll( '.js-video-container' ) ).forEach(
    videoContainer => main( videoContainer )
  )

  /**
   * Get HTML nodes and call functions.
   *
   * @param {object} videoContainer The video main node container.
   */
  function main( videoContainer ) {
    /**
     * Video Player Docs: https://github.com/sampotts/plyr
     */
    const player = new window.Plyr( videoContainer.querySelector( '.js-video' ), {
      ratio: '16:9'
    })

    videoContainer
      .querySelector( '.js-video-poster' )
      .addEventListener( 'click', () => openModal() )

    /**
     * On modal opening.
     */
    function openModal() {
      const modalId = videoContainer.dataset.modalId

      /**
       * Modal Docs: https://micromodal.now.sh/
       */
      MicroModal.show( modalId,{
        onClose: closeModal,
        awaitCloseAnimation: true,
      })

      player.play()
    }

    /**
     * On modal closing.
     */
    function closeModal() {
      if ( !isPlaying( player ) ) {
        player.stop()
      }
    }

    /**
     * Checks if the video is playing.
     *
     * @param {object} player The video player.
     *
     * @returns {boolean} Is the player playing a video?
     */
    function isPlaying( player ) {
      return player.currentTime > 0 && !player.paused && !player.ended && player.readyState > 2
    }
  }
}
